<script>
import { mapActions } from 'vuex'
import { add, edit } from '@/api/pessoa'
import fields from './fields'
import { setFocus } from '@/services/crud'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data: () => ({
    fields,
    form: {}
  }),
  methods: {
    ...mapActions({
      toaster: 'modal/toaster'
    }),
    focuInicial () {
      setFocus('input[type="text"]', this.$refs.form.$el)
    },
    refresh (data) {
      this.form = JSON.parse(JSON.stringify(data))
      if (!this.form.id) this.$refs.form.instance.resetValues()
      this.focuInicial()
    },
    async salvar () {
      // Salvar Editar
      try {
        let valida = this.$refs.form.instance.validate()
        if (!valida.isValid) throw new Error('Campos Inválidos')
        let data = {}
        if (this.form.id) {
          data = await edit(this.form.id, this.form)
          this.toaster({ message: 'Editado com sucesso!', color: 'success' })
        } else {
          data = await add(this.form)
          this.toaster({ message: 'Adicionado com sucesso!', color: 'success' })
        }
        this.$emit('save', data)
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar">
      <app-grupopessoa-select slot="grupo" slot-scope="data" :model="form.grupo_pessoa" @change="v => form.grupo_pessoa = v" />
      <app-tabeladesconto-select slot="desconto" slot-scope="data" :model="form.tabela_desconto" @change="v => form.tabela_desconto = v" />
      <app-tabelapreco-select slot="preco" slot-scope="data" :model="form.tabela_preco" @change="v => form.tabela_preco = v" />
      <app-segmento-select slot="segmento" slot-scope="data" :model="form.segmento" @change="v => form.segmento = v" />
    </dx-form>
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
